import { UpgradeActionTypes } from './types';
import { action } from 'typesafe-actions';

export const userPlanUpgradeStart = (payload: any) =>
  action(UpgradeActionTypes.USER_PLAN_UPGRADE_START, payload);
export const userPlanUpgradeSuccess = (payload: any) =>
  action(UpgradeActionTypes.USER_PLAN_UPGRADE_SUCCESS, payload);
export const userPlanUpgradeFailure = (error: string) =>
  action(UpgradeActionTypes.USER_PLAN_UPGRADE_FAILURE, error);
